import React, { useEffect } from "react";
import logo from "../static/logo.png";
import { useSelector } from "react-redux";
import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "../store";

// 创建 memoized selector
const selectUrls = createSelector(
  (state: RootState) => state.apkUrl,
  (state: RootState) => state.exeUrl,
  (state: RootState) => state.ipaUrl,
  // 只有当 apkUrl 或 exeUrl 变化时才会重新计算
  (apkUrl, exeUrl, ipaUrl) => ({ apkUrl, exeUrl, ipaUrl })
);

const Header: React.FC = () => {
  // function isMobile() {
  //   const mobileReg =
  //     /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;
  //   return mobileReg.test(navigator.userAgent);
  // }
  function isMobile() {
    const mobileReg =
      /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;
    const userAgent = navigator.userAgent;

    if (mobileReg.test(userAgent)) {
      if (/Android/i.test(userAgent)) {
        return "Android";
      } else if (/iPhone|iPad|iPod/i.test(userAgent)) {
        return "iOS";
      }
    }

    return "window";
  }
  useEffect(() => {
    if (isMobile() === "iOS") {
    }
  }, []);

  // 使用 memoized selector
  const { apkUrl, exeUrl, ipaUrl } = useSelector(selectUrls);
  function checkAppInstalled() {
    // 1. 定义应用的Scheme协议（需与Android客户端注册的一致，如"myapp://"）
    const appScheme = "myapp://open_deep_surf";
    // 或使用应用包名（需客户端支持，部分浏览器可能有限制）
    // const appPackage = "com.mycompany.myapp";
    // const appScheme = `intent://#Intent;package=${appPackage};scheme=myapp;end`;

    // 2. 尝试唤醒应用
    const iframe = document.createElement("iframe");
    iframe.style.display = "none";
    iframe.src = appScheme; // 触发应用唤醒
    document.body.appendChild(iframe);

    // 3. 超时检测（若3秒内未唤醒，则视为未安装）
    const checkTimeout = 3000; // 超时时间（毫秒）
    let isInstalled = false;

    // 监听页面是否被隐藏（若唤醒成功，页面会被切换到后台，visibilityState变为hidden）
    document.addEventListener("visibilitychange", () => {
      if (document.visibilityState === "hidden") {
        isInstalled = true; // 应用已安装，触发了跳转
      }
    });

    // 超时后判断结果
    setTimeout(() => {
      document.body.removeChild(iframe); // 清理iframe
      if (isInstalled) {
        // console.log("应用已安装，已唤醒");
      } else {
        window.location.href = apkUrl;
        // 这里可以添加下载逻辑，如跳转到应用商店
        // window.location.href = 'https://play.google.com/store/apps/details?id=com.mycompany.myapp';
      }
    }, checkTimeout);
  }
  return (
    <div className="w-full h-16 py-siderPad px-siderPad justify-between    flex items-center  backdrop-blur-[4px] text-[16px]  top-0 z-[10]">
      <div className="flex items-center gap-5">
        <div className="flex items-center gap-2">
          <img src={logo} alt="" className="w-[32px] h-[32px] " />
          <p className="text-[#333333FF] text-[20px]">DeepSurf</p>
        </div>
        <div className="w-[1px] h-[26px] bg-[#00000008]"></div>
      </div>
      <p
        className=" bg-[#4F6BFEFF] w-[146px] h-[32px] leading-[32px] text-center text-[#FFFFFFFF] text-[14px] rounded-full cursor-pointer hover:bg-[#4c67ee]"
        onClick={() => {
          // window.open(isMobile() === "window" ? exeUrl : apkUrl);
          console.log(isMobile());
          if (isMobile() === "window") {
            window.open(exeUrl);
          } else if (isMobile() === "Android") {
            checkAppInstalled();
          } else {
            window.open(ipaUrl);
            console.log("🚀 ~ ipaUrl:", ipaUrl);
          }
        }}
      >
        打开DeepSurf
      </p>
    </div>
  );
};
export default Header;
